module.exports = __webpack_public_path__ + "static/media/clock.cad07bf4.svg";